export enum RoomDetailsMountComponent {
  HotelViewRoomsSection = `hotelViewRoomsSection`,
  RoomDetailsOverlay = `roomDetailsOverlay`
}

export const DEFAULT_VISIBLE_OFFERS = 2
